import { Grid } from '@mui/material';
import { calculateClusterCapacity } from '@siren-frontend/shared';
import bytes from 'bytes';

// import { formatStorage } from 'services/cluster';
// TODO: Calculator: replace with shared service
/**
 * checks if the given value is a real number
 * @param {Number|*} value
 * @returns {Boolean}
 */
function isEmptyNumber(value) {
  return typeof value === 'undefined' || Number.isNaN(value);
}

export function formatMemory(memory) {
  if (isEmptyNumber(memory)) return 'N/A';
  return bytes(memory * 1024 * 1024, { unitSeparator: ' ' }) || 'N/A';
}

/**
 * Format storage output
 * includes option to return string with percentages
 * @param {Number} storage
 * @param {Number} [storageFree] if exists - returns as percentage { value: '80%', health: true }
 * @returns {Number|Object}
 */

export function formatStorage(storage, storageFree) {
  if (isEmptyNumber(storage)) return 'N/A';

  const isStorageMetricInvalid = storage === 0 && storageFree === 0;
  if (isStorageMetricInvalid) return { health: true, value: 'N/A' };

  if (storageFree) {
    // returns value and health
    const storagePercent = Math.round(
      (storage * 100) / (storage + storageFree)
    );
    const isStorageHealthy = storagePercent < 75;
    return {
      health: isStorageHealthy,
      value: `${storagePercent}%`,
    };
  }
  return bytes(storage * 1024 * 1024 * 1024, { unitSeparator: ' ' }) || 'N/A';
}

function CalculatorTechSpecs({ calculatedCluster, internalParams }) {
  const clusterCapacity = calculateClusterCapacity(
    calculatedCluster?.cluster,
    3,
    internalParams
  );
  const maxDataSetSize = (clusterCapacity.dataset / 2 ** 10).toLocaleString();
  const peakLoad = clusterCapacity.peakLoad.toLocaleString();
  const sustainedLoad = clusterCapacity.sustainedLoad.toLocaleString();

  const nodesLabel = `${calculatedCluster?.cluster?.nodes} x ${calculatedCluster?.cluster?.instanceType?.name}`;
  const diskStorage = formatStorage(clusterCapacity.storage);
  const vcpuCount = clusterCapacity.vcpu.toLocaleString();

  return (
    <>
      <h4>Technical Specs</h4>
      <h5>Cluster capacity</h5>

      <Grid container className="cluster-capacity">
        <Grid item xs={4}>
          Max dataset size
        </Grid>
        <Grid item xs={8} className="roboto-font">
          <span className="font-bolder">{maxDataSetSize}</span> TB
        </Grid>
        <Grid item xs={4}>
          Peak throughput
        </Grid>
        <Grid item xs={8} className="roboto-font">
          <span className="font-bolder">{peakLoad}</span> ops/sec
        </Grid>
        <Grid item xs={4}>
          Sustained throughput
        </Grid>
        <Grid item xs={8} className="roboto-font">
          <span className="font-bolder">{sustainedLoad}</span> ops/sec
        </Grid>
      </Grid>
      <h5>Cluster specs</h5>
      <Grid container className="cluster-specs">
        <Grid item xs={4}>
          Nodes
        </Grid>
        <Grid item xs={8} className="roboto-font">
          <span className="font-bolder">{nodesLabel}</span> (
          {calculatedCluster?.cluster?.instanceType?.vcpu} vCPUs,{' '}
          {calculatedCluster?.cluster?.instanceType?.memory} GB RAM,{' '}
          {formatStorage(calculatedCluster?.cluster?.instanceType?.storage)}{' '}
          storage)
        </Grid>
        <Grid item xs={4}>
          Disk storage
        </Grid>
        <Grid item xs={8} className="roboto-font">
          <span className="font-bolder">{diskStorage}</span>
        </Grid>
        <Grid item xs={4}>
          Total vCPU
        </Grid>
        <Grid item xs={8} className="roboto-font">
          <span className="font-bolder">{vcpuCount}</span>
        </Grid>
      </Grid>
    </>
  );
}

export default CalculatorTechSpecs;
